import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const AuthApi = {
  createLogin(data) {
    return http.post('/login', data).then((response) => response);
  },

  createRegistration(data) {
    return http.post('/api/developers/registration', data).then((response) => response.data.data);
  },

  createPasswordResetEmail(data) {
    return http.post('/password/email', data).then((response) => response.data);
  },

  createEmailVerification(verificationToken) {
    return http.post(`/api/tokens/${verificationToken}/validate`).then((response) => response.data.data);
  },

  createIdentityProvider(data) {
    return http.post(`${teamPath()}/identity-providers`, data).then((response) => response.data);
  },
};
